export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5091.8fee49e3.jpg";